import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BookingsPage } from './bookings.page';
import { AuthGuard } from '../services/user/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: BookingsPage
  },
  {
    path: 'booking-form-summary/:id',
    loadChildren: () => import('./booking-form/booking-form-summary/booking-form-summary.module').then( m => m.BookingFormSummaryPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'booking-confirmation/:bookingID',
    loadChildren: () => import('./booking-form/booking-form-confirmation/booking-form-confirmation.module').then( m => m.BookingFormConfirmationPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'booking-form-client-list',
    loadChildren: () => import('./booking-form/booking-form-client-list/booking-form-client-list.module').then( m => m.BookingFormClientListPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'booking-form-service-list-page',
    loadChildren: () => import('./booking-form/booking-form-service-list-page/booking-form-service-list-page.module').then( m => m.BookingFormServiceListPagePageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'booking-form-time-off',
    loadChildren: () => import('./booking-form/booking-form-time-off/booking-form-time-off.module').then( m => m.BookingFormTimeOffPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'booking-form-date-change',
    loadChildren: () => import('./booking-form/booking-form-date-change/booking-form-date-change.module').then( m => m.BookingFormDateChangePageModule),
    canActivate: [AuthGuard]

  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookingsPageRoutingModule {}
